import type React from "react";
import { useContext } from "react";
import { Link } from "react-router";
import { Alert } from "~/components/Alert";
import {
	ContentContainer,
	ContentContainerWrapper,
} from "~/components/ContentContainer";
import { DefaultLayout } from "~/components/Layout";
import { config } from "~/config";
import { SessionContext } from "~/ory";

export const Home: React.FC = () => {
	const session = useContext(SessionContext);
	if (!session) return <p>Unauthenticated</p>;

	const BasicActions = (
		<>
			<div className="mt-2 md:flex justify-between md:gap-3">
				<div className="w-full inline-block text-center mt-6">
					<a href="/settings" className="btn btn-t4-primary rounded-full">
						EDIT ACCOUNT
					</a>
				</div>
				<div className="w-full inline-block text-center mt-6">
					<a className="btn btn-t4-border rounded-full" href="/logout">
						LOGOUT
					</a>
				</div>
			</div>
			<p className="mt-8 text-center">
				<Link
					to={config.tierivPortalUrl}
					target="_blank"
					rel="noopener noreferrer"
				>
					GO TO TIER IV PORTAL
				</Link>
			</p>
		</>
	);

	const UnverifiedActions = (
		<>
			<Alert type="warning" withIcon>
				Verify email address.
				<br />
				Please check your email box.
			</Alert>
			<div className="mt-6 md:flex justify-between md:gap-3">
				<div className="w-full inline-block text-center">
					<Link to="/verify" className="btn btn-t4-border rounded-full">
						RESEND
					</Link>
				</div>
				<div className="w-full inline-block text-center">
					<a className="btn btn-t4-border rounded-full" href="/logout">
						LOGOUT
					</a>
				</div>
			</div>
		</>
	);

	const action = session.account.identity.email_verified
		? BasicActions
		: UnverifiedActions;
	return (
		<DefaultLayout>
			<ContentContainerWrapper>
				<ContentContainer>
					<section className="font-normal flex flex-col gap-8 mt-8">
						<dl>
							<dt className="mb-2 text-xs">USER ID</dt>
							<dd className="text-xs">{session.account.subject_id}</dd>
						</dl>
						<dl>
							<dt className="mb-2 text-xs">NAME</dt>
							<dd className="text-xs">
								{session.account.identity.name.first}{" "}
								{session.account.identity.name.last}
							</dd>
						</dl>
						<dl>
							<dt className="mb-2 text-xs">EMAIL</dt>
							<dd className="text-xs">{session.account.identity.email}</dd>
						</dl>
					</section>
					{action}
				</ContentContainer>
			</ContentContainerWrapper>
		</DefaultLayout>
	);
};
